import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import _cloneDeep from 'lodash/cloneDeep';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormioCustomComponent, FormioLoader } from 'dp-formio';
import { Utils } from 'formiojs';

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
declare var echarts: any;

@Component({
	selector: 'dynamic-chart-wrapper',
	templateUrl: './dynamic-chart-wrapper.component.html',
	// styleUrls: ['./dynamic-chart-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [FormioLoader],
})
export class DynamicChartWrapperComponent
	implements FormioCustomComponent<any>, OnChanges, AfterViewInit, OnDestroy {
	dir: 'rtl' | 'ltr';

	@ViewChild('form') form: any;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Output() formSubmitted = new EventEmitter<any>();
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;
	disabled: boolean;
	isReady = false;
	chart: any;

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	constructor(private translateService: TranslateService,
		private loader: FormioLoader) {
		this.changeDirection(this.translateService.currentLang);
	}

	ngAfterViewInit(): void {
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	ngOnDestroy() {
		this.chart?.destroy();
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.customOptions) {
			this.loader.loading = true;
			if (this.customOptions.eventName) this.makeCalls();
			else {
				this.loader.loading = false;
				setTimeout(() => this.initChart(), 250);
			}
		}
	}

	private makeCalls() {
		if (this.formioComponent?.root?.form?.properties[this.customOptions.eventName]) {
			this.formioComponent.root.events.emit('formio.makeCalls',
				this.formioComponent.root.form,
				null,
				JSON.parse(this.formioComponent.root.form.properties[this.customOptions.eventName]),
				[],
				[],
				true,
				() => this.initChart());
		}
	}

	private initChart() {
		this.loader.loading = false;
		if (this.customOptions.echartsOption) {
			this.initEChart();
		} else {
			const labels = this.customOptions.labels ?
				Utils.evaluate(this.customOptions.labels, { translate: this.translateService.instant, data: this.data }) :
				[];
			const ctx = (document.getElementById(`chartJs-${this.formioComponent.component.key}`) as any).getContext("2d");
			Chart.getChart(`chartJs-${this.formioComponent.component.key}`)?.destroy();
			this.chart = new Chart(ctx, {
				type: this.customOptions.type,
				data: {
					labels: this.customOptions.translateLabels ?
						labels.map(q => this.translateService.instant(`forms.common.${q}`)) :
						labels,
					datasets: Utils.evaluate(this.customOptions.datasets, { translate: this.translateService, data: this.data })
				},
				options: this.customOptions.options
			});
			setTimeout(() => this.isReady = true);
		}
	}

	private initEChart() {
		const chart = echarts.init(document.getElementById(`eChart-${this.formioComponent.component.key}`));
		const option = Utils.evaluate(this.customOptions.echartsOption, { translate: this.translateService, data: this.data });
		chart.setOption(option);
		chart.resize();
		window.addEventListener('resize', () => { chart.resize(); });
	}
}
